var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedaltArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45339 5.67461C3.6331 5.46495 3.94875 5.44067 4.15841 5.62038L8.49968 9.34147L12.841 5.62038C13.0506 5.44067 13.3663 5.46495 13.546 5.67461C13.7257 5.88428 13.7014 6.19993 13.4917 6.37964L8.82508 10.3796C8.63783 10.5401 8.36153 10.5401 8.17429 10.3796L3.50762 6.37964C3.29796 6.19993 3.27368 5.88428 3.45339 5.67461Z",
    fill: "#b91618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedaltArrowDown);
export default __webpack_public_path__ + "static/media/redaltArrowDown.37d5ddbb3f2d8c13a2e6262683708561.svg";
export { ForwardRef as ReactComponent };